<template>
  <aside>
    <h6>Ratings Summary</h6>
    <article class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Symbol</th>
            <th>Name</th>
            <th>Rating</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="rating in ratings" :key="rating.id">
            <td>{{ rating.instrument.symbol }}</td>
            <td>
              <router-link :to="`/company?company_id=${rating.instrument.company.id}`"
                           class="blue-grey-text text-darken-4 strong small"
              >
                {{ rating.instrument.company.name | pretty }}
              </router-link>
            </td>
            <td>
              {{ rating.points }}
              <i class="pink-text text-lighten-3 fas fa-heart small" v-if="rating.points > 0" />
              <i class="grey-text text-lighten-2 fas fa-heart small" v-if="rating.points === 0" />
              <i class="blue-text text-accent-1 fas fa-heart-broken small" v-if="rating.points < 0" />
            </td>
          </tr>
        </tbody>
      </table>
    </article>
  </aside>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MiniRatings',
  components: {},
  props: {
    analystId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      ratings: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    async fetchRatings() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/ratings/query/?analyst_id=${this.analystId}`);
      this.ratings = this.sortArray(this.sortArray(data, 'instrument.name', true), 'points', true);
    },
  },
  mounted() {
    this.fetchRatings();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.table-wrapper {
  border: 1px solid $tmf-gains;
  border-radius: 10px;
  padding: 0px 15px 0px 15px;
}
</style>
